import { render, staticRenderFns } from "./DebtPage.vue?vue&type=template&id=fbb3ef36&"
import script from "./DebtPage.vue?vue&type=script&lang=js&"
export * from "./DebtPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports